import React, { Suspense } from 'react';

import Spin from 'components/Spin';

interface AppSuspenseProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Componente Suspense simplificado
 * O loading de inicialização é gerenciado pelo InitializationProvider
 */
const AppSuspense: React.FC<AppSuspenseProps> = ({ children, fallback = <Spin /> }) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

export default AppSuspense;
